module.exports = __webpack_public_path__ + "static/media/expand-feedback-icon.5bcd5448.svg";